import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import Poll from './Poll';
import Thanks from './Thanks';
import NotFound from './NotFound';
import { history } from '../helpers';
import Home from './Home';
import AdminHome from './admin/AdminHome';
// import PollPicker from './PollPicker';
import PollViewer from './PollViewer';
import PollActivityViewer from './PollActivityViewer';
import Results from './Results';
// import Followups from './Followups';

const AppRouter = () => {
  return (
    <Router history={history}>
      <Switch>
        {/* unprotected routes */}
        <Route exact path='/' component={Home} />
        <Route exact path='/p/:pollId' component={Poll} />
        <Route exact path='/p/:pollId/thanks' component={Thanks} />
        <Route exact path='/p/:pollId/results' component={Results} />

        {/* protected routes */}
        {/*<PrivateRoute exact path='/admin' component={PollPicker} />*/}
        <PrivateRoute exact path='/admin' component={AdminHome} />
        <PrivateRoute exact path='/admin/:pollId' component={PollViewer} />
        <PrivateRoute exact path='/admin/:pollId/activity' component={PollActivityViewer} />
        
        {/* Disabled feature due to PID requirements */}
        {/* <PrivateRoute
          exact
          path='/admin/:pollId/followups'
          component={Followups}
        /> */}

        {/* 404 error handler */}
        <Route exact component={NotFound} />
      </Switch>
    </Router>
  );
};

export default AppRouter;
